/* 
    Handles the form created by clicking 'New Job Note' button on the WorkOrderForm
*/

import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { UploadFile } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';

import DeleteIcon from '../images/delete.png';

export class WorkOrderNoteForm extends Component {
  static displayName = WorkOrderNoteForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      model: props.model,
      alert: props.alert,
      deltaPosition: { x: 0, y: 0 },
    };
    //
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDeleteFile = this.handleDeleteFile.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);

    this.jhSearchRef = React.createRef();
    this.typeDropdownRef = React.createRef();

    this.state = {
      model: props.model,
      alert: props.alert,
      deltaPosition: { x: 0, y: 0 },
      typeDropdownOpen: false,
    };

    this.toggleTypeDropdown = this.toggleTypeDropdown.bind(this);
    this.handleTypeSelect = this.handleTypeSelect.bind(this);
    this.handleDocumentMouseDown = this.handleDocumentMouseDown.bind(this);
  }

  toggleTypeDropdown() {
    this.setState((prev) => ({
      typeDropdownOpen: !prev.typeDropdownOpen,
    }));
  }

  handleTypeSelect(value) {
    const model = { ...this.state.model, JobHistoryType: value };

    this.setState({
      model,
      typeDropdownOpen: false, // ✅ close after selecting
    });
  }

  componentDidMount() {
    const isNewJobNote =
      this.state.model && this.state.model.EventType === 'insert';
    if (isNewJobNote) {
      setTimeout(() => {
        this.setState({ typeDropdownOpen: true });
      }, 150);
    }

    document.addEventListener('keydown', this.keydownHandler);
    document.addEventListener('mousedown', this.handleDocumentMouseDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
  }

  handleDocumentMouseDown(e) {
    if (!this.state.typeDropdownOpen) {
      return;
    }

    if (
      this.typeDropdownRef.current &&
      !this.typeDropdownRef.current.contains(e.target)
    ) {
      this.setState({ typeDropdownOpen: false });
    }
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  handleChange(e) {
    let model = { ...this.state.model };
    model[e.target.name] = e.target.value;

    this.setState({ model });
  }

  handleFileChange(e) {
    let model = { ...this.state.model };
    model.FileName = e.target.files[0].name;
    model.FormFile = e.target.files[0];

    this.setState({ model });
  }

  handleDeleteFile() {
    this.fileUpload.value = null;

    let model = { ...this.state.model };
    model.FileName = '';
    model.FileLocation = '';

    this.setState({ model });
  }

  async keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      // ALT+S
      this.onSave();
    }
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      },
    );
  }

  onSave() {
    let model = { ...this.state.model };

    if (model.EventType === 'insert') {
      model.JobHistoryId = null;
      model.CreateByUserId = this.user.userid;
    } else if (model.EventType === 'update') {
      model.UpdateByUserId = this.user.userid;
    }

    var formData = new FormData();
    formData.append('EventType', model.EventType);
    formData.append('JobHistoryId', model.JobHistoryId);
    formData.append('JobId', model.JobId);
    formData.append('JobHistoryName', model.JobHistoryName);
    formData.append('Description', model.Description);
    formData.append('Contact', model.Contact);
    formData.append('ContactEmail', model.ContactEmail);
    formData.append('FileLocation', model.FileLocation);
    formData.append('FileName', model.FileName);
    formData.append('JobHistoryType', model.JobHistoryType);
    formData.append('CreateDateTime', model.CreateDateTime);
    formData.append('CreateByUserId', model.CreateByUserId);
    formData.append('UpdateByUserId', model.UpdateByUserId);
    formData.append('UpdateDateTime', model.UpdateDateTime);
    //formData.append("IsDeletedFlg", model.IsDeletedFlg);
    formData.append('FormFile', model.FormFile);

    UploadFile('/savejobhistory', this.user.token, formData).then((data) => {
      if (data === 'Success') {
        this.props.handleSaveEventSuccess({
          message: data,
          modal: data === 'Success' ? false : true,
          color: data === 'Success' ? 'success' : 'warning',
          model: model,
        });
      } else {
        this.handleSaveEventSuccess({
          message: data,
          modal: true,
          color: 'warning',
        });
      }
    });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;

    return (
      <Draggable handle=".handle" onDrag={this.handleDrag} {...dragHandlers}>
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              height: '150px',
              width: '500px',
            }}
            backdrop="static"
          >
            <ModalHeader className="handle">New/Edit Job History</ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                    >
                      {this.state.alert.message}
                    </Alert>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '70px' }}>
                        Type:
                      </InputGroupText>
                      <div ref={this.typeDropdownRef}>
                        <Dropdown
                          isOpen={this.state.typeDropdownOpen}
                          toggle={() => {}} // handled manually so outside clicks can close without changing selection
                          disabled={!this.state.model.IsEditableFlg}
                        >
                          <DropdownToggle
                            caret
                            size="sm"
                            color="light"
                            className="form-control text-start"
                            onClick={() =>
                              this.setState({ typeDropdownOpen: true })
                            }
                          >
                            {this.state.model.JobHistoryType}
                          </DropdownToggle>

                          <DropdownMenu>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Attachment')
                              }
                            >
                              Attachment
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('To Auth Dept')
                              }
                            >
                              To Auth Dept
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('To Booking Dept')
                              }
                            >
                              To Booking Dept
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('To Conf Dept')
                              }
                            >
                              To Conf Dept
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => this.handleTypeSelect('Job Note')}
                            >
                              Job Note
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Authorization')
                              }
                            >
                              Authorization
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => this.handleTypeSelect('My Job')}
                            >
                              My Job
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Claimant Confirmed')
                              }
                            >
                              Claimant Confirmed
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Int Communication')
                              }
                            >
                              Int Communication
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Int Final Conf')
                              }
                            >
                              Int Final Conf
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Int Cancelation')
                              }
                            >
                              Int Cancelation
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => this.handleTypeSelect('Rep Email')}
                            >
                              Rep Email
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Provider Conf')
                              }
                            >
                              Provider Conf
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Schedule Change')
                              }
                            >
                              Schedule Change
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Scheduling Note')
                              }
                            >
                              Scheduling Note
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Special Billing')
                              }
                            >
                              Special Billing
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Special Handling')
                              }
                            >
                              Special Handling
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Waiting on Call Back')
                              }
                            >
                              Waiting on Call Back
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Transport Requested')
                              }
                            >
                              Transport Requested
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Transport Confirmed')
                              }
                            >
                              Transport Confirmed
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Remote Clm Conf')
                              }
                            >
                              Remote Clm Conf
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Remote Int Conf')
                              }
                            >
                              Remote Int Conf
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Remote Prov Conf')
                              }
                            >
                              Remote Prov Conf
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                this.handleTypeSelect('Interpreter Attachment')
                              }
                            >
                              Interpreter Attachment
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <InputGroupText>Description:</InputGroupText>
                      <textarea
                        name="Description"
                        value={this.state.model.Description}
                        ref={this.jhSearchRef}
                        className="form-control"
                        onChange={this.handleChange}
                        disabled={!this.state.model.IsEditableFlg}
                      ></textarea>
                    </InputGroup>
                  </Col>
                </Row>
                <hr />
                {(this.state.model.JobHistoryType === 'Attachment' ||
                  this.state.model.JobHistoryType === 'Interpreter Attachment') && <hr />}
                {(this.state.model.JobHistoryType === 'Attachment' ||
                  this.state.model.JobHistoryType === 'Interpreter Attachment') && (
                  <Row>
                    <Col className={'col-2'} />
                    <Col
                      className={
                        this.state.model.FileName === '' ? 'col-10' : 'col-10'
                      }
                      style={{ position: 'relative' }}
                    >
                      <div style={{ position: 'relative' }}>
                        <input
                          id="file"
                          type="file"
                          name="fileUpload"
                          className="form-control"
                          onChange={this.handleFileChange}
                          ref={(ref) => (this.fileUpload = ref)}
                        />

                        <span
                          style={{
                            position: 'absolute',
                            left: '12px',
                            top: '6px',
                            pointerEvents: 'none',
                          }}
                        >
                          {this.state.model.FileName === ''
                            ? 'Drag and Drop'
                            : this.state.model.FileName}
                        </span>
                      </div>
                    </Col>

                    <Col className="col-1">
                      <img
                        src={DeleteIcon}
                        style={{
                          width: '14px',
                          height: '14px',
                          cursor: 'pointer',
                          display:
                            this.state.model.FileName === '' ? 'none' : null,
                        }}
                        onClick={this.handleDeleteFile}
                        alt="Delete"
                      />
                    </Col>
                  </Row>
                )}
              </div>
            </ModalBody>
          </Modal>
        </div>
      </Draggable>
    );
  }
}
